module.exports = __webpack_public_path__ + "img/facebook.7cc5f3df.svg";